import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="bg-brand-dark py-16 sm:py-24 lg:py-32 px-5 sm:px-6 md:px-12 lg:px-24" data-id="element-86">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 sm:gap-16 lg:gap-24 items-center" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="order-2 lg:order-1 relative w-full aspect-[3/4] max-w-md mx-auto lg:max-w-none" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/acooiqDzAZobJoYNZD1XmT/PHOTO_BUREAU_FOND_MODERNE.png" alt="Rebeca Oliveira au bureau" className="w-full h-full object-cover rounded-[8px] shadow-2xl" data-id="element-89" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="order-1 lg:order-2 flex flex-col" data-id="element-90">
          <h2 className="text-[26px] sm:text-[32px] lg:text-[36px] font-bold text-brand-cream mb-6 sm:mb-8 leading-tight" data-id="element-91">
            C'est exactement ce que je règle.
            <br data-id="element-92" />
            En 3 à 5 jours. Garanti.
          </h2>

          <div className="space-y-5 sm:space-y-6 text-[15px] sm:text-[17px] text-brand-cream leading-[1.8] sm:leading-[1.9] mb-8 sm:mb-10" data-id="element-93">
            <p data-id="element-94">Je suis Rebeca Oliveira, fondatrice de Visibilia.</p>
            <p data-id="element-95">
              Pas une agence. Pas une étudiante en marketing.
              <br data-id="element-96" />
              Une femme de terrain — 20 ans de direction d'entreprise
              internationale.
              <br data-id="element-97" />5 ans à bâtir la présence digitale d'entrepreneurs et de
              PME.
            </p>
            <p data-id="element-98">
              J'ai travaillé des deux côtés de la table. Je sais exactement ce
              que ça coûte d'avoir une mauvaise image en ligne. Et ce que ça
              rapporte d'en avoir une bonne.
            </p>
            <p data-id="element-99">
              Ce que je crée pour vous — c'est un profil LinkedIn qui fait dire
              à vos clients idéaux :<br data-id="element-100" />
              <span className="italic" data-id="element-101">
                "Cette personne, je lui fais confiance."
              </span>
            </p>
          </div>

          <div className="w-[60px] h-[1px] bg-brand-gold/40 mx-auto lg:mx-0 my-6" data-id="element-102"></div>

          <div className="grid grid-cols-3 gap-2 sm:gap-4 mb-8" data-id="element-103">
            <div className="bg-brand-darker rounded-[8px] p-3 sm:p-5 text-center flex flex-col justify-center" data-id="element-104">
              <span className="text-[22px] sm:text-[28px] lg:text-[32px] font-bold text-brand-gold mb-1 leading-none font-serif" data-id="element-105">
                20 ans
              </span>
              <span className="text-[11px] sm:text-[13px] text-brand-cream/75 leading-tight" data-id="element-106">
                Direction
                <br data-id="element-107" />
                internationale
              </span>
            </div>
            <div className="bg-brand-darker rounded-[8px] p-3 sm:p-5 text-center flex flex-col justify-center" data-id="element-108">
              <span className="text-[22px] sm:text-[28px] lg:text-[32px] font-bold text-brand-gold mb-1 leading-none font-serif" data-id="element-109">
                5 ans
              </span>
              <span className="text-[11px] sm:text-[13px] text-brand-cream/75 leading-tight" data-id="element-110">
                Médias
                <br data-id="element-111" />
                sociaux
              </span>
            </div>
            <div className="bg-brand-darker rounded-[8px] p-3 sm:p-5 text-center flex flex-col justify-center" data-id="element-112">
              <span className="text-[22px] sm:text-[28px] lg:text-[32px] font-bold text-brand-gold mb-1 leading-none font-serif" data-id="element-113">
                3
              </span>
              <span className="text-[11px] sm:text-[13px] text-brand-cream/75 leading-tight" data-id="element-114">
                Langues
                <br data-id="element-115" />
                FR·ES·EN
              </span>
            </div>
          </div>

          <p className="text-[14px] text-brand-gold text-center lg:text-left" data-id="element-116">
            FR · ES · EN 🌐
          </p>
        </motion.div>
      </div>
    </section>;
}